import { isValid } from 'cpf';
import Validator from '../validator';

export default class CpfValidator extends Validator {
  static validate(string) {
    return isValid(string);
  }
}
